import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import posthog from 'posthog-js';
import DashboardLayout from './components/dashboard/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Feedback from './pages/Feedback';
import SupervisorInformation from './pages/SupervisorInformation';
import ManageSupervisors from './pages/ManageSupervisors';
import GPSTracking from './pages/GPSTracking';
import SupervisorsList from './pages/supervisors/SupervisorsList';
import SupervisorDetail from './pages/supervisors/SupervisorDetail';
import FeedbackAdminList from './pages/feedback/FeedbackAdminList';
import FeedbackDetail from './pages/feedback/FeedbackDetail';
import Fame from './pages/Fame';
import SMSBlast from './pages/SMSBlast';
import FraudReviewQueue from './pages/review/FraudReviewQueue';
import SiteManagerAdmin from './pages/admin/SiteManagerAdmin';
import IgpClaimsPage from './pages/admin/IgpClaimsPage';
import SiteManagerView from './pages/SiteManagerView';
import { AdminProvider } from './contexts/AdminContext';
import AdminBadge from './components/admin/AdminBadge';
import AdminGate from './components/admin/AdminGate';
import SiteManagerGate from './components/admin/SiteManagerGate';
import { auth } from './firebase';

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    try {
      posthog.capture('$pageview', { $current_url: window.location.href });
    } catch { /* posthog not initialised */ }
  }, [location.pathname]);
  return null;
}

function App() {
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, () => {
      setAuthReady(true);
    });
    return unsubscribe;
  }, []);

  if (!authReady) {
    return null;
  }

  return (
    <AdminProvider>
      <Router>
        <PageTracker />
        <Routes>
          <Route path="/fame" element={<Fame />} />
          <Route path="/sms-blast" element={<SMSBlast />} />
          <Route path="/gps-tracking" element={<GPSTracking />} />
          <Route path="/supervisors" element={<AdminGate><SupervisorsList /></AdminGate>} />
          <Route path="/supervisors/:uid" element={<AdminGate><SupervisorDetail /></AdminGate>} />
          <Route path="/feedback/admin" element={<AdminGate><FeedbackAdminList /></AdminGate>} />
          <Route path="/feedback/admin/:id" element={<AdminGate><FeedbackDetail /></AdminGate>} />
          <Route path="/review" element={<AdminGate><FraudReviewQueue /></AdminGate>} />
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
          </Route>
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="feedback" element={<AdminGate><Feedback /></AdminGate>} />
            <Route path="supervisor-information" element={<AdminGate><SupervisorInformation /></AdminGate>} />
            <Route path="manage-supervisors" element={<AdminGate><ManageSupervisors /></AdminGate>} />
          </Route>
          <Route path="/admin/site-managers" element={<AdminGate><SiteManagerAdmin /></AdminGate>} />
          <Route path="/admin/igp-claims" element={<AdminGate><IgpClaimsPage /></AdminGate>} />
          <Route path="/site-view" element={<SiteManagerGate><SiteManagerView /></SiteManagerGate>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <AdminBadge />
      </Router>
    </AdminProvider>
  );
}

export default App;
